import { render, staticRenderFns } from "./VoucherPurchasesWithoutPoints.vue?vue&type=template&id=4d3922fd"
import script from "./VoucherPurchasesWithoutPoints.vue?vue&type=script&lang=js"
export * from "./VoucherPurchasesWithoutPoints.vue?vue&type=script&lang=js"
import style0 from "./VoucherPurchasesWithoutPoints.vue?vue&type=style&index=0&id=4d3922fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports